import React from 'react';
import { Flex } from '@withjoy/joykit';

export interface LayoutAddComponentListItemProps {
  onClick: () => void;
}

export const LayoutAddComponentListItem: React.FC<LayoutAddComponentListItemProps> = props => {
  return (
    <Flex
      __css={{ _hover: { cursor: 'pointer', backgroundColor: 'mono2', color: 'linkHover' } }}
      columnGap={5}
      paddingX={6}
      paddingY={5}
      alignItems="center"
      borderColor="mono3"
      borderWidth="1px"
      borderStyle="solid"
      borderRadius={12}
      onClick={props.onClick}
    >
      {props.children}
    </Flex>
  );
};
